export const EntitySelectorTab = Object.freeze({
	Recent: 'recents',
});
